// extracted by mini-css-extract-plugin
export default {"button":"TariffsList__button___G7WQ2","profit":"TariffsList__profit___JgIG6","image":"TariffsList__image___epUyn"};